import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2818fe78&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2818fe78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818fe78",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Discussion: require('/var/jenkins_home/workspace/prod-web-xfans/components/discussion.vue').default})
